import { motion } from "framer-motion";

const THEMES = [
  { n: "01", season: "Q1 · Jan–Mar", title: "Ambition", copy: "Dreaming out loud in a world that tells us to be realistic." },
  { n: "02", season: "Q2 · Apr–Jun", title: "Money & Meaning", copy: "Building wealth without losing yourself along the way." },
  { n: "03", season: "Q3 · Jul–Sep", title: "The Body Issue", copy: "Health, image, sport, and everything we inherit from culture." },
  { n: "04", season: "Q4 · Oct–Dec", title: "Beginnings", copy: "Life after school, first jobs, first cities, first failures." },
];

export default function QuarterlyThemes() {
  return (
    <section id="themes" data-testid="quarterly-themes" className="relative border-t border-[#2E1A6B]/15">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#2E1A6B] mb-4">
              Quarterly Themes · 2026
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-[#1A1A1A] max-w-2xl">
              Four issues.<br />One year in the making.
            </h2>
          </div>
          <p className="text-base md:text-lg text-[#4A4A4A] max-w-sm">
            Each quarter, Listen commits to a single theme — reported deeply, illustrated boldly.
          </p>
        </div>

        <ul className="border-t border-[#2E1A6B]/20">
          {THEMES.map((t, i) => (
            <motion.li
              key={t.n}
              data-testid={`theme-${t.n}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="grid grid-cols-12 gap-4 py-6 md:py-8 border-b border-[#2E1A6B]/20 items-baseline group cursor-default"
            >
              <div className="col-span-2 md:col-span-1 font-display text-3xl md:text-5xl text-[#2E1A6B]">
                {t.n}
              </div>
              <div className="col-span-10 md:col-span-3 text-xs uppercase tracking-[0.25em] font-semibold text-[#4A4A4A] pt-2 md:pt-4">
                {t.season}
              </div>
              <div className="col-span-12 md:col-span-5 font-display text-3xl md:text-5xl leading-[1] tracking-tight text-[#1A1A1A] group-hover:italic transition-all">
                {t.title}
              </div>
              <div className="col-span-12 md:col-span-3 text-sm text-[#4A4A4A] leading-relaxed pt-2 md:pt-4">
                {t.copy}
              </div>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
